import GDPRStore from "./GDPRStore";

const REFRESH_TOKEN_KEY = "refreshToken";
const AUTH_TOKEN_KEY = "authToken";

export default class AuthStore {
  static hasRefreshToken(): boolean {
    return AuthStore.loadRefreshToken() !== null;
  }

  static loadRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  static saveRefreshToken(token: string): void {
    if (token) {
      localStorage.setItem(REFRESH_TOKEN_KEY, token);
    } else {
      AuthStore.removeRefreshToken();
    }
  }

  static removeRefreshToken(): void {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }

  static loadAuthToken(): string | null {
    return sessionStorage.getItem(AUTH_TOKEN_KEY);
  }

  static saveAuthToken(token: string): void {
    if (token) {
      sessionStorage.setItem(AUTH_TOKEN_KEY, token);
    } else {
      AuthStore.removeAuthToken();
    }
  }

  static removeAuthToken(): void {
    sessionStorage.removeItem(AUTH_TOKEN_KEY);
  }

  static removeLogin() {
    GDPRStore.removeGdprConsent();
    AuthStore.removeAuthToken();
    AuthStore.removeRefreshToken();
  }
}
